import {Injectable} from "@angular/core";

function _window() : any {
    // return the global native browser window object
    return window;
}

@Injectable()
export class WindowRef {
    get nativeWindow() : any {
        return _window();
    }

    goHref(path:string):void {
        this.nativeWindow.location.href = path;
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/window-ref.ts